export interface Airline {
  code: string;
  name: string;
}

export enum Direction {
  LEFT = 'left',
  RIGHT = 'right',
}
